<script lang="ts">
  import Modal from "app/components/+shared/Modal/Modal.svelte";
  import OnboardingForm from "./OnboardingForm.svelte";
  import { session } from "$stores/auth";
  import { getStores } from "app/stores";

  const { userPreferences } = getStores();

  $: onboardUser = !!(
    $session.signInProvider !== "custom" &&
    !$session.loading &&
    $session?.firebaseUser?.emailVerified &&
    !$session?.user?.handle
  );
</script>

<Modal
  open={onboardUser}
  maxWidth="max-w-[566px]"
  backdropVariant="secondary"
  withCloseIcon={false}
  disallowClickOutside
>
  <div
    slot="backdrop"
    class="mx-auto flex max-w-[520px] flex-col items-center justify-center text-center"
  >
    <div class="mb-6 text-2xl font-medium text-neutral-700 dark:text-neutral-200">Get started</div>
    <div class="text-md mb-6 hidden text-neutral-600 md:block dark:text-neutral-400">
      Complete the form below to set up your user profile.
    </div>
  </div>
  {#if $session.user}
    <OnboardingForm user={$session.user} {userPreferences} />
  {/if}
</Modal>
